import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type SessionContextService from 'tio-employee/services/session-context';
import type ReimaginedDataService from 'tio-employee/services/reimagined-data';

export default class PslfIndexRoute extends Route {
  @service declare sessionContext: SessionContextService;
  @service declare reimaginedData: ReimaginedDataService;

  async model() {
    const [pslfData, dataSourceInfo] = await Promise.all([
      this.reimaginedData.fetchPslfData(),
      this.reimaginedData.getDataSourceInfo(),
    ]);

    return {
      clientId: this.sessionContext.currentEmployee?.company?.id || 'demo-healthcare',
      pslfData,
      dataSourceInfo,
    };
  }
}
